// Set only after confirming the correct Moxie payment form and live terms.
// Do not use a report/intake form as payment or infer academy enrollment.
export const gbpOffer = {
 path: '/gbp-optimization',
 checkoutUrl: '',
 checkoutVerified: false,
 videoUrl: '',
 academyUrl: '',
 academyVerified: false,
 price: 299,
};